import React, { Component } from 'react';
import { connect } from 'react-redux';
import { stateCleanup } from '../../store/actions/AuthActions';
import styles from './TestComplete.scss';
import success_top from '../../assets/images/testcomplete/success-top.png';
import success_bot_r from '../../assets/images/testcomplete/success-bot-r.png';
import success_bot_l from '../../assets/images/testcomplete/success-bot-l.png';
//allows the user to change language
class TestComplete extends Component {
  componentDidUnmount() {
    this.props.stateCleanup();
  }

  render() {
    return (
      <div className={styles['c-msg-box']}>
        <div className={styles['c-msg-box__top-image']}>
          <img
            src={success_top}
            alt="success-top"
          />
        </div>
        <h2 className="sub-header-font-size-mid bold">
          {this.props.testTitle
            ? this.props.testTitle
            : sessionStorage.getItem('test_title')
            ? sessionStorage.getItem('test_title')
            : 'Test Completed'}
        </h2>
        <p>
          Your test has been successfully submitted
          <br />
          {this.props.companyName
            ? this.props.companyName
            : sessionStorage.getItem('company_name')}{' '}
          has received your test report
        </p>
        <div className={styles['c-msg-box__bottom-image']}>
          <img
            className={styles['c-msg-box__bottom-image-left']}
            src={success_bot_l}
            alt="success-bot-r"
          />
          <img
            className={styles['c-msg-box__bottom-image-right']}
            src={success_bot_r}
            alt="success-bot-l"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    testTitle: state.assessment.testInfo.title,
    companyName: state.auth.company_details.name,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    stateCleanup: () => dispatch(stateCleanup()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TestComplete);
